import ConfigSectionData from 'models/ConfigSectionData';
import GeneralSection from '../general-section/GeneralSection';
import { PlistData } from 'models/PlistData';
import { omit } from 'lodash-es';
import { useTranslation } from 'react-i18next';

interface PlistSectionWrapperProps {
  sectionKey: string;
  translationKey: string;
  plistSection: PlistData;
  setPlistSection: (value: PlistData) => void;
  handleSave?: () => void;
  resetFields?: () => void;
}

const PlistSectionWrapper = ({
  sectionKey,
  translationKey,
  plistSection,
  setPlistSection,
  handleSave,
  resetFields,
}: PlistSectionWrapperProps): JSX.Element => {
  const { t } = useTranslation();

  function setSection(key: string, value: string) {
    setPlistSection({
      ...plistSection,
      [sectionKey]: { ...(plistSection[sectionKey] as ConfigSectionData), [key]: value },
    });
  }

  function deleteField(key: string) {
    setPlistSection({
      ...plistSection,
      [sectionKey]: { ...omit(plistSection[sectionKey] as ConfigSectionData, key) },
    });
  }

  return (
    <GeneralSection
      section={plistSection[sectionKey] as ConfigSectionData}
      title={t(translationKey)}
      setSection={setSection}
      deleteField={deleteField}
      fieldsToExclude={null}
      isDynamic
      handleSave={handleSave}
      resetFields={resetFields}
    />
  );
};

PlistSectionWrapper.defaultProps = {
  handleSave: () => {
    /* do nothing */
  },
  resetFields: () => {
    /* do nothing */
  },
};

export default PlistSectionWrapper;
